import OfferBanner from "./OfferBanner/OfferBanner";
import Navbar from "./Navbar/Navbar";
import Hero from "./Hero/Hero";
import PrimaryButton from "./PrimaryButton";
import AboutUs from "./AboutUs/AboutUs";
import Services from "./ServicesSection/Services";
import Cta from "./Cta/Cta";
import Testimonial from "./Testimonial/Testimonial";
import BookAppointment from "./BookAppointment/BookAppointment";
import Footer from "./Footer/Footer";
import ModalPopup from "./ModalPopup/ModalPopup";
import CookieConsentBanner from "./CookieConsentBanner";
import AosAnimation from "./AosAnimation";
import Pricing from "./Pricing/Pricing";
import Preloader from "./Preloader/Preloader";
import FeaturedBlog from "./FeaturedBlog/FeaturedBlog";
import LatestBlog from "./LatestBlog/LatestBlog";
import Providers from "./Providers/Providers";
import Team from "./Team/Team";
import SpecialServiceDisplay from "./SpecialServiceDisplay";


export {OfferBanner, Navbar, Hero, PrimaryButton, AboutUs, Services, 
    Cta, Testimonial, BookAppointment, Footer, ModalPopup,
     CookieConsentBanner, AosAnimation, Pricing, Preloader, FeaturedBlog, LatestBlog, Providers, Team, SpecialServiceDisplay};